import React from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { Header } from '../../components/Header/Header'
import dp from '../../assets/images/i.png'
import { FaUsers } from 'react-icons/fa'
import { BsPersonLinesFill, BsPersonBadge } from 'react-icons/bs'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { useState } from 'react'
import { useEffect } from 'react'
import moment from 'moment'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const EditRequest = () => {
  toast.configure()
  const navigate = useNavigate()
  const params = useParams()
  const [data, setData] = useState([])
  const [status, setStatus] = useState('')
  const [reason, setReason] = useState('')
  const [onHoldreason, setOnHoldReason] = useState('')
  const [onHold, setOnHold] = useState(false)
  const [rejected, setRejected] = useState(false)
  const username = localStorage.getItem('user')
  const today = new Date()

  const getData = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'hr-approval/getRequestById', { id: params.id })
      .then((res) => {
        setData(res.data.data[0])
        setStatus(res.data.data[0].status)

        if (
          res.data.data[0].hr_reason_reject !== '' &&
          res.data.data[0].status === 'Rejected'
        ) {
          setRejected(true)
          setReason(res.data.data[0].hr_reason_reject)
        }
        if (
          res.data.data[0].hr_reason_onhold !== '' &&
          res.data.data[0].status === 'On Hold'
        ) {
          setOnHold(true)
          setOnHoldReason(res.data.data[0].hr_reason_onhold)
        }
      })
      .catch((err) => {})
  }
  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const updateStatus = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'hr-approval/updateReimburseReuqest', {
        id: params.id,
        status: status,
        approved_by: username,
        approved_date: today,
        payee_name: data.payee_name,
        email: data.email,
        reason_of_reject: reason,
        reason_of_onhold: onHoldreason,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          navigate('/dashboard')
        }, 2000)
      })
      .catch((err) => {})
  }
  // hr request edit view
  return (
    <>
      <Header />
      <div className="container editRequest mt-3 p-4">
        {/* breadcrumbs */}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/dashboard" className="link text-primary">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item">Edit Request</li>
            <li className="breadcrumb-item active" aria-current="page">
              {data.payee_name}
            </li>
          </ol>
        </nav>
        {/* the card will display the details of employee department,desgination,etc. 
        and reimburse request details where hr can update the state of request */}
        {data ? (
          <>
            <h5 className="text-primary mt-5 mb-4">Edit Request</h5>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column align-items-center text-center">
                      <img
                        src={dp}
                        alt="Admin"
                        className="rounded-circle"
                        height={80}
                      />
                      <div className="mt-3">
                        <h4>{data.payee_name}</h4>
                        <p className="text-secondary mb-1">{data.email}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mt-3">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item row d-flex">
                      <div className="col-md-5 d-flex align-items-center">
                        <BsPersonBadge />
                        <h6 className="mb-0 mx-2">Employee ID</h6>
                      </div>
                      <span className="text-secondary col-md-7  d-flex justify-content-end">
                        {data.desig_id}
                      </span>
                    </li>
                    <li className="list-group-item row d-flex">
                      <div className="col-md-4 d-flex align-items-center">
                        <BsPersonLinesFill />
                        <h6 className="mb-0 mx-2">Department</h6>
                      </div>
                      <span className="text-secondary col-md-8  d-flex justify-content-end">
                        {data.dept_name}
                      </span>
                    </li>

                    <li className="list-group-item row d-flex">
                      <div className="col-md-4  d-flex align-items-center">
                        <FaUsers />
                        <h6 className="mb-0 mx-2">Manager</h6>
                      </div>
                      <span className="text-secondary col-md-8  d-flex justify-content-end">
                        {data.manager_name}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="mt-3 d-flex row">
                        <h6 className="col-md mx-2">HR Status</h6>
                        <h6
                          className="text-secondary mb-1 col-md d-flex justify-content-start"
                          style={{ marginLeft: '1.5rem' }}
                        >
                          {data.status}
                        </h6>
                      </div>
                    </div>
                    <div className="row">
                      {' '}
                      <div className="d-flex d-flex justify-content-between mx-2 col-md">
                        <div className="mt-3 ">
                          <h6>Last Updated By</h6>
                          <h6 className="text-secondary mb-1">
                            {data.hr_approved_by}
                          </h6>
                        </div>
                      </div>
                      <div className="d-flex d-flex justify-content-between mx-3 col-md">
                        <div className="mt-3 ">
                          <h6>Last Updated Date</h6>
                          <h6 className="text-secondary mb-1">
                            {data.hr_approved_date === 'Pending'
                              ? 'Pending'
                              : moment(data.hr_approved_date).format(
                                  'DD-MM-YYYY',
                                )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="mt-3 d-flex row">
                        <h6 className="col-md mx-2">Final Status</h6>
                        <h6
                          className="text-secondary mb-1 col-md d-flex justify-content-start"
                          style={{ marginLeft: '1.5rem' }}
                        >
                          {data.final_status}
                        </h6>
                      </div>
                    </div>
                    <div className="row">
                      {' '}
                      {data.final_status === 'Rejected' ? (
                        <>
                          <div className="mt-3 d-flex row">
                            <h6 className="col-md mx-2">Reason</h6>
                            <h6
                              className="text-secondary mb-1 col-md d-flex justify-content-start"
                              style={{ marginLeft: '1.5rem' }}
                            >
                              {data.admin_reason_reject}
                            </h6>
                          </div>
                        </>
                      ) : data.final_status === 'On Hold' ? (
                        <>
                          <div className="mt-3 d-flex row">
                            <h6 className="col-md mx-2">Reason</h6>
                            <h6
                              className="text-secondary mb-1 col-md d-flex justify-content-start"
                              style={{ marginLeft: '1.5rem' }}
                            >
                              {data.admin_reason_onhold}
                            </h6>
                          </div>
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className="row">
                      {' '}
                      <div className="d-flex d-flex justify-content-between mx-2 col-md">
                        <div className="mt-3 ">
                          <h6>Last Updated By</h6>
                          <h6 className="text-secondary mb-1">
                            {data.admin_approved_by}
                          </h6>
                        </div>
                      </div>
                      <div className="d-flex d-flex justify-content-between mx-3 col-md">
                        <div className="mt-3 ">
                          <h6>Last Updated Date</h6>
                          <h6 className="text-secondary mb-1">
                            {data.admin_approved_date === 'Pending'
                              ? 'Pending'
                              : moment(data.admin_approved_date).format(
                                  'DD-MM-YYYY',
                                )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-8">
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Initiated Date</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {moment(data.initiate_date).format('DD-MM-YYYY')}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Expense Date</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {moment(data.date_of_expense).format('DD-MM-YYYY')}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Paid Amount</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        ₹ {data.paid_amount}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Payment Mode</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {data.mode_name}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Purpose Of Expenditure</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {data.purpose_of_expenditure}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <h6 className="mb-0">Expenditure Category</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        {data.expenditure_category}
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className="col-sm-12">
                        <a href={data.invoice} target="_blank" rel="noreferrer">
                          <button className="btn btn-outline-primary mx-3">
                            View Invoice
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <h6 className="d-flex align-items-center mb-3">
                      <i className="material-icons text-info mx-2">Actions</i>
                    </h6>
                    {status ? (
                      <div className="mb-3 col-md-6">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          <h6>Update Status</h6>
                        </label>
                        <select
                          className="form-select"
                          defaultValue={status}
                          name="status"
                          onChange={(e) => {
                            setStatus(e.target.value)
                            if (e.target.value === 'Rejected') {
                              setOnHold(false)
                              setRejected(true)
                            } else if (e.target.value === 'On Hold') {
                              setRejected(false)
                              setOnHold(true)
                            } else {
                              setRejected(false)
                              setOnHold(false)
                            }
                          }}
                        >
                          <option selected value="Pending" disabled>
                            Select
                          </option>
                          <option value="Approved">Approve</option>
                          <option value="Rejected">Reject</option>
                          <option value="On Hold">On Hold</option>
                        </select>
                      </div>
                    ) : (
                      ''
                    )}
                    {rejected ? (
                      <div className="mb-3 col-md-6">
                        <textarea
                          className="form-control"
                          placeholder="Reason"
                          name="reason"
                          value={reason}
                          onChange={(e) => setReason(e.target.value)}
                          required
                        />
                      </div>
                    ) : onHold ? (
                      <div>
                        <div className="col-md-6 mb-3">
                          <textarea
                            className="form-control"
                            placeholder="Reason"
                            name="onhold"
                            value={onHoldreason}
                            onChange={(e) => setOnHoldReason(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className="d-grid gap-2 d-md-block">
                      <button
                        className={
                          data.status === status && data.resubmit === 0
                            ? 'btn btn-primary disabled mx-2'
                            : 'btn btn-primary mx-2'
                        }
                        type="submit"
                        onClick={() => {
                          updateStatus()
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ''
        )}
      </div>
    </>
  )
}
